//lib
import { Box } from "@mui/system";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { OverFlowStyled } from "./overflow-text.style";

const OverflowText = (props) => {
  const { id, className, sx, arrow = true, tooltipPlacement } = props;
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textElement = useRef();
  useEffect(() => {
    if (textElement && textElement.current)
      setIsOverflowed(
        textElement?.current?.scrollWidth > textElement?.current?.clientWidth
      );
  }, [props.children]);

  return (
    <OverFlowStyled>
      <Tooltip
        title={
          <div className="tooltip-padding" onClick={(e) => e.stopPropagation()}>
            {props.children}
          </div>
        }
        classes={{
          tooltip: "desc-tooltip-tile no-padding",
          arrow: "desc-tooltip-arrow",
        }}
        arrow={arrow}
        placement={tooltipPlacement || "top"}
        disableHoverListener={!isOverflowed}
      >
        <Box
          id={id}
          className={className || ""}
          ref={textElement}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            ...sx,
          }}
        >
          {props.children}
        </Box>
      </Tooltip>
    </OverFlowStyled>
  );
};

OverflowText.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  arrow: PropTypes.bool,
  sx: PropTypes.object,
  tooltipPlacement: PropTypes.oneOf([
    "left",
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top",
  ]),
};

export default OverflowText;
